<template>
  <v-app id="app">
    <RouterView />
    <v-snackbar v-model="snackbar.status" :color="snackbar.color">{{
      snackbar.message
    }}</v-snackbar>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex'
import '@/assets/styles/custom-table.css'

export default {
  name: `App`,
  computed: {
    ...mapGetters(`App`, [`snackbar`]),
  },
}
</script>

<style lang="scss">
@font-face {
  font-family: 'Roboto';
  src: url(./assets/fonts/Roboto/Roboto-Regular.ttf);
}
%max-size {
  width: 100%;
  height: 100%;
}
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
html,
body {
  @extend %max-size;
  font-family: 'Roboto', sans-serif;
}
.max-content-height {
  height: calc(100vh - 108px) !important;
}
</style>
